import React from 'react';
import Panel from '../../components/atom/Panel';
import Icon from '../../components/atom/Icon';
import WeatherIcon from '../../components/atom/WeatherIcon';
import './Badge.css';

const Badge = ({ iconName, textValue, iconType = 'icons' }) => {
  const renderIcon = () => {
    if (iconType === 'moon') {
      // Hier übergeben wir "type", damit WeatherIcon den richtigen Schlüssel findet
      return <WeatherIcon className="moon-icons"  type={iconName} />;
    } else {
      return <Icon name={iconName} width="100%" height="100%" />;
    }
  };

  return (
    <Panel className="badge-panel">
      <div className="badge-content">
        <div className="badge-icon">
          {renderIcon()}
        </div>
        <div className="badge-text">
          <span className={`badge-textValue ${iconType === 'moon' ? 'badge-textValue-moon' : ''}`}>
            {textValue}
          </span>
        </div>
      </div>
    </Panel>
  );
};

export default Badge;
